import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Archivo } from '../../Archivo';
import { RadioButton } from 'primereact/radiobutton';
import servicioArchivos from '../../../servicio/ServicioArchivos';
import { validacionCertificadosDigitales } from '../../../servicio/ServicioValidacionCertificadosDigitales';
import servicioObjetos from '../../../servicio/ServicioObjetos';

export const Formulario = (props) => {

    const [tcFiel, setTcFiel] = useState({});
    const [archivoCer, setArchivoCer] = useState({});
    const [archivoKey, setArchivoKey] = useState({});
    const [mostrarArchivos, setMostrarArchivos] = useState(true);
    const { onFormularioOk } = props;
    let { growl } = props;

    const handleChange = e => {
        const { name, value } = e.target;
        setTcFiel(valoresUsuarioPrevios => ({
            ...valoresUsuarioPrevios,
            [name]: value
        }));
    };

    const cargarArchivoCer = (event) => {
        let archivo = event.target.files[0];
        servicioArchivos.obtenerBytesBase64StringArchivoPromise(archivo, archivo, 'data').then(response => {
            setArchivoCer(response);
        }).catch(error => {

        });
    }
    const cargarArchivoKey = (event) => {
        let archivo = event.target.files[0];
        servicioArchivos.obtenerBytesBase64StringArchivoPromise(archivo, archivo, 'data').then(response => {
            setArchivoKey(response);
        }).catch(error => {

        });
    }

    const guardar = () => {
        try {
            if (servicioObjetos.esObjetoVacio(tcFiel.tipoDescarga))
                throw new Error("Debes de elegir un tipo de descargas");
            let validacionCertificado = validacionCertificadosDigitales(archivoCer.data, archivoKey.data, tcFiel.contrasenaLlave, tcFiel.rfc, "FIEL");
            let objetoFormulario = {};
            objetoFormulario.fechaCreacion = validacionCertificado.fechaInicial;
            objetoFormulario.fechaExpiracion = validacionCertificado.fechaFinal;
            objetoFormulario.numeroCertificado = validacionCertificado.numeroCertificado;
            objetoFormulario.archivoCer = archivoCer.data;
            objetoFormulario.archivoKey = archivoKey.data;
            objetoFormulario.contrasenaLlave = tcFiel.contrasenaLlave;
            objetoFormulario.nombreArchivoCer = archivoCer.name;
            objetoFormulario.nombreArchivoKey = archivoKey.name;
            objetoFormulario.rfc = tcFiel.rfc;
            objetoFormulario.tipoDescarga = tcFiel.tipoDescarga;
            objetoFormulario.estado = 0;
            onFormularioOk(objetoFormulario);
        } catch (error) {
            growl.current.clear();
            growl.current.show({ severity: 'error', summary: 'Error', detail: error.message, life: 10000 });
        }
    }


    const reiniciar = () => {
        setMostrarArchivos(false);
        setTcFiel({});
        setTimeout(() => {
            setMostrarArchivos(true);
        }, 100);
    }

    return (
        <div>
            <div className="card-w-title">
                <h1>Carga de e.firma</h1>
                <div className="p-grid">
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="archivoCer">Certificador (.cer):</label>
                    </div>
                    <div className="p-col-12 p-md-10">
                        {mostrarArchivos ? <Archivo id="archivoCer" etiqueta="Cargar archivo .cer" nombre="archivoCer" cambio={cargarArchivoCer} aceptar=".cer" /> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="archivoKey">Clave privada (.key):</label>
                    </div>
                    <div className="p-col-12 p-md-10">
                        {mostrarArchivos ? <Archivo id="archivoKey" etiqueta="Cargar archivo .key" nombre="archivoKey" cambio={cargarArchivoKey} aceptar=".key" /> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="claveKey">Contraseña de clave privada:</label>
                    </div>
                    <div className="p-col-12 p-md-10">
                        <InputText id="contrasenaLlave" name="contrasenaLlave" style={{ width: '50%' }} value={tcFiel.contrasenaLlave || ''}
                            onChange={handleChange} />
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="rfc">Rfc:</label>
                    </div>
                    <div className="p-col-12 p-md-10">
                        <InputText id="rfc" name="rfc" style={{ width: '50%' }} value={tcFiel.rfc || ''}
                            onChange={handleChange} />
                    </div>
                    <div className="p-col-12 p-md-12">
                        <label htmlFor="rfc">Tipo Descargas:</label>
                    </div>
                    <div className="p-col-12 p-md-2">
                    </div>
                    <div className="p-col-12 p-md-10">
                        <RadioButton inputId="diarias" name="tipoDescarga" value="Diarias"
                            onChange={handleChange} checked={tcFiel.tipoDescarga === 'Diarias'} />
                        <label htmlFor="diarias" className="p-radiobutton-label">Diarias</label>
                    </div>
                    <div className="p-col-12 p-md-2">
                    </div>
                    <div className="p-col-12 p-md-10">
                        <RadioButton inputId="semanales" name="tipoDescarga" value="Semanales"
                            onChange={handleChange} checked={tcFiel.tipoDescarga === 'Semanales'} />
                        <label htmlFor="semanales" className="p-radiobutton-label">Semanales</label>
                    </div>
                    <div className="p-col-12 p-md-2">
                    </div>
                    <div className="p-col-12 p-md-10">
                        <RadioButton inputId="quincenales" name="tipoDescarga" value="Quincenales"
                            onChange={handleChange} checked={tcFiel.tipoDescarga === 'Quincenales'} />
                        <label htmlFor="quincenales" className="p-radiobutton-label">Quincenales</label>
                    </div>
                    <div className="p-col-12 p-md-2">
                    </div>
                    <div className="p-col-12 p-md-10">
                        <RadioButton inputId="mensuales" name="tipoDescarga" value="Mensuales"
                            onChange={handleChange} checked={tcFiel.tipoDescarga === 'Mensuales'} />
                        <label htmlFor="mensuales" className="p-radiobutton-label">Mensuales</label>
                    </div>

                    <div className="p-col-12 p-md-2">

                    </div>
                    <div className="p-col-12 p-md-10">
                        <Button label="Guardar" icon="pi-md-save" onClick={guardar} />
                        <Button label="Limpiar" icon="pi-md-refresh" onClick={reiniciar} />
                    </div>
                </div>
            </div>
        </div>
    );
}